import React from 'react';

type FigureProps = {
  src: string;
  alt: string;
  caption?: string;
};

function Figure({ src, alt, caption }: FigureProps) {
  return (
    <figure className="blog-figure">
      <img src={src} alt={alt} />
      {caption ? <figcaption>{caption}</figcaption> : null}
    </figure>
  );
}

export default Figure;
